import { createSlice } from "@reduxjs/toolkit";
import { PartnersThunk } from "../Thunk/PartnersThunk";

let initState = {
	reload: true,
	sliders: [],
	error: null,
};

const PartnersReducer = createSlice({
	name: "PartnersReducer",

	initialState: initState,
	reducers: {},
	extraReducers: (builder) => {
		builder

			.addCase(PartnersThunk.pending, (state, action) => {
				state.reload = true;
			})
			.addCase(PartnersThunk.fulfilled, (state, action) => {
				state.reload = false;
				state.sliders = action.payload.data;
			});
	},
});
export default PartnersReducer.reducer;
